// extracted by css-extract-rspack-plugin
export default {"wrapper":"c2FbHi","layout":"M7b2St","content":"UxNSwk","form-container":"m3Aqms","formContainer":"m3Aqms","footer":"ZLg0Gg","details":"uL3_Mo"};